import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=52938da6&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=52938da6&lang=scss&scoped=true"
import style1 from "./ProductItem.vue?vue&type=style&index=1&id=52938da6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52938da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52938da6')) {
      api.createRecord('52938da6', component.options)
    } else {
      api.reload('52938da6', component.options)
    }
    module.hot.accept("./ProductItem.vue?vue&type=template&id=52938da6&scoped=true", function () {
      api.rerender('52938da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/ProductItem.vue"
export default component.exports